import { render } from "./SettingsIcon.vue?vue&type=template&id=c30e13dc"
const script = {}
script.render = render

export default script